import React, { useState, useRef } from 'react'
import Tooltip from 'particles/Tooltip'
import TextParticle from 'particles/Text'
import styled, { useTheme } from 'particles/themes/styled'
import { useTranslation } from 'react-i18next'

interface LinkInBioWithTooltipProps {
    linkInBioUrl: string
}

const EllipsisText = styled(TextParticle)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: block;
    cursor: pointer;
`

const LinkInBioWithTooltip: React.FC<LinkInBioWithTooltipProps> = ({ linkInBioUrl }) => {
    const [t] = useTranslation()
    const particlesTheme = useTheme()
    const [tooltip, setTooltip] = useState<string | null>(null)
    const textRef = useRef<HTMLDivElement>(null)

    const onUrlHover = (e: React.MouseEvent<HTMLDivElement>) => {
        if (textRef.current) {
            const isOverflow = textRef.current.scrollWidth > textRef.current.offsetWidth
            if (isOverflow) {
                setTooltip(linkInBioUrl)
            } else {
                setTooltip(null)
            }
        }
    }

    return (
        <div
            style={{
                width: '100%',
                margin: `${particlesTheme.spacing[100]} 0 ${particlesTheme.spacing[200]} 0`,
                textAlign: 'left',
                position: 'relative',
            }}
            onClick={e => e.stopPropagation()}
        >
            <TextParticle scale="bodyS400" color="secondary">
                {t('submission.review.linkInBioHeader')}
            </TextParticle>
            <Tooltip
                label={
                    tooltip ? (
                        <TextParticle
                            scale="caption400"
                            color="primaryInverse"
                            style={{
                                wordBreak: 'break-all',
                                whiteSpace: 'normal',
                                maxWidth: '100%',
                                overflowWrap: 'break-word',
                            }}
                        >
                            {tooltip}
                        </TextParticle>
                    ) : null
                }
                placement="top"
            >
                <div
                    style={{
                        width: '100%',
                        paddingTop: particlesTheme.spacing[100],
                        paddingBottom: particlesTheme.spacing[100],
                        paddingLeft: particlesTheme.spacing[200],
                        borderLeft: `1px solid ${particlesTheme.colors.border.secondary}`,
                        borderTopLeftRadius: particlesTheme.spacing[100],
                        borderBottomLeftRadius: particlesTheme.spacing[100],
                        textAlign: 'left',
                        cursor: 'pointer',
                        minHeight: '1.4em',
                        display: 'block',
                        boxSizing: 'border-box',
                    }}
                    onMouseEnter={onUrlHover}
                >
                    <EllipsisText ref={textRef} scale="bodyS700">
                        {linkInBioUrl}
                    </EllipsisText>
                </div>
            </Tooltip>
        </div>
    )
}

export default LinkInBioWithTooltip
